import { render, staticRenderFns } from "./roi.vue?vue&type=template&id=06b40668&scoped=true&"
import script from "./roi.vue?vue&type=script&lang=js&"
export * from "./roi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b40668",
  null
  
)

export default component.exports